import "core-js/modules/es6.array.map";
import React from "react";
import ClassNames from "classnames";

var SubpageNavigation = function SubpageNavigation(_ref) {
  var hasSubpages = _ref.hasSubpages,
      subpages = _ref.subpages,
      onClickNavItem = _ref.onClickNavItem;

  if (hasSubpages) {
    return React.createElement("nav", {
      className: "l-side-nav side-nav"
    }, React.createElement("ul", {
      className: "side-nav__group"
    }, subpages.map(function (_ref2, i) {
      var slug = _ref2.slug,
          title = _ref2.title,
          isActive = _ref2.isActive;
      var classNames = ClassNames("side-nav__item", {
        "side-nav__item--active": isActive
      });
      return React.createElement("li", {
        key: i,
        className: classNames
      }, React.createElement("a", {
        className: "side-nav__link",
        href: "#".concat(slug),
        onClick: function onClick(e) {
          return onClickNavItem(e, slug);
        }
      }, title));
    })));
  }

  return "";
};

export default SubpageNavigation;